import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export function MarketingNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [active, setActive] = useState("");

  useEffect(() => {
    if (location.pathname !== "/") { setActive(""); return; }
    const ids = ["how", "pricing"];
    const els = ids.map((id) => document.getElementById(id)).filter(Boolean);
    if (!els.length) return;
    const vis = {};
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => { vis[e.target.id] = e.isIntersecting; });
        setActive(ids.find((id) => vis[id]) || "");
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [location.pathname]);

  const linkStyle = (id) => ({
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: 13.5,
    position: "relative",
    color: active === id ? "var(--orange)" : undefined,
    fontWeight: active === id ? 700 : undefined,
    transition: "color 0.2s ease",
  });

  const Underline = ({ id }) =>
    active === id ? (
      <span style={{ position: "absolute", left: 0, right: 0, bottom: -7, height: 2, background: "var(--orange)", borderRadius: 2 }} />
    ) : null;

  const goSection = (id) => {
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <header
      className="mkt-nav-blur"
      data-testid="marketing-nav"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        borderBottom: "1px solid var(--line)",
      }}
    >
      <div
        style={{
          maxWidth: 1140,
          margin: "0 auto",
          padding: "14px 22px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <button
          onClick={() => navigate("/")}
          data-testid="nav-home-logo"
          aria-label="HDG Creative Studio — home"
          style={{ display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", cursor: "pointer" }}
        >
          <img src="/hdg-logo.jpg" alt="HeyDesignGuy" style={{ height: 30, width: 30, objectFit: "contain", borderRadius: 7, background: "#fff", padding: 3 }} />
          <span className="font-display" style={{ fontWeight: 700, fontSize: 15, color: "var(--tprimary)", letterSpacing: "-0.01em" }}>HDG Creative Studio</span>
        </button>

        <nav className="hidden md:flex" style={{ alignItems: "center", gap: 28 }}>
          <button onClick={() => goSection("how")} data-testid="nav-how" aria-current={active === "how" ? "true" : undefined} className="app-link font-body" style={linkStyle("how")}>How it works<Underline id="how" /></button>
          <button onClick={() => navigate("/pricing")} data-testid="nav-pricing" className="app-link font-body" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13.5 }}>Pricing</button>
          <button onClick={() => navigate("/about-us")} data-testid="nav-about" className="app-link font-body" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13.5 }}>About</button>
        </nav>

        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button onClick={() => navigate("/login")} data-testid="nav-login" className="app-link font-body hidden sm:inline-flex" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13.5 }}>Log in</button>
          <button onClick={() => navigate("/start")} data-testid="nav-start-free" className="btn-primary" style={{ padding: "9px 16px", fontSize: 13 }}>Start free</button>
        </div>
      </div>
    </header>
  );
}
